import React from 'react';
import * as BodyPositionIcons from './Icons/BodyPositionIcons';
import styles from './ProcessedCalculatedData.module.scss';

const bodyPositionMapping = [
  { id: 1, icon: <BodyPositionIcons.LyingOnBack /> },
  { id: 2, icon: <BodyPositionIcons.LeanBack/> },
  { id: 3, icon: <BodyPositionIcons.Stand/> },
  { id: 4, icon: <BodyPositionIcons.LeanForward/> },
  { id: 5, icon: <BodyPositionIcons.LyingFaceDown/> },
  { id: 6, icon: <BodyPositionIcons.LyingRightSide/> },
  { id: 7, icon: <BodyPositionIcons.LyingLeftSide/> },
  { id: 8, icon: <BodyPositionIcons.LeanRight/> },
  { id: 9, icon: <BodyPositionIcons.LeanLeft/> },
];

export function BodyPositionDisplay({ bodyPosition, className, wrapperClassName, scale }) {
  // Only show body position for valid values (1-9)
  const isValidPosition = bodyPosition && bodyPosition >= 1 && bodyPosition <= 9;
  
  if (!isValidPosition) {
    return null;
  }
  
  const bodyPositionIcon = bodyPositionMapping.find(x => x.id === bodyPosition)?.icon;
  
  if (!bodyPositionIcon) {
    return null;
  }
  
  // If wrapperClassName is provided, wrap in an additional div
  const scaleStyle = scale ? { transform: `scale(${scale})`, transformOrigin: 'top left' } : undefined;

  if (wrapperClassName) {
    return (
      <div className={wrapperClassName}>
        <div className={`${styles.bodyIcon} ${className || ''}`} style={scaleStyle}>
          {bodyPositionIcon}
        </div>
      </div>
    );
  }
  
  return (
    <div className={`${styles.bodyIcon} ${className || ''}`} style={scaleStyle}>
      {bodyPositionIcon}
    </div>
  );
}
